import script from "./CardPageProdComp.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPageProdComp.vue?vue&type=script&setup=true&lang=js"

import "./CardPageProdComp.vue?vue&type=style&index=0&id=36d52cde&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36d52cde"]])

export default __exports__